import { Component, OnInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {deslocamentosModuleName, tiposDeslocamentos} from "../shared/data.service";
import {Deslocamento} from "../shared/deslocamento.model";
import {editRoute, newRouteFemale} from "../../../shared/services/data.service";
import {DeslocamentoNavigationService} from "../shared/deslocamento-navigation.service";
import {DeslocamentoApiService} from "../shared/deslocamento-api.service";
import {DeslocamentoService} from "../shared/deslocamento.service";
import {UtilService} from "../../../shared/services/util.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {viagensModuleName} from "../../shared/data.service";
import {Funcionario} from "../../../recursos-humanos/funcionarios/funcionario.model";
import {FuncionarioApiService} from "../../../recursos-humanos/funcionarios/funcionario-api.service";
import {FuncionarioService} from "../../../recursos-humanos/funcionarios/funcionario.service";
import {funcionariosQueryComPessoa} from "../../../recursos-humanos/funcionarios/data.service";
import {Destino} from "../../destinos/shared/destino.model";
import {DestinoApiService} from "../../destinos/shared/destino-api.service";
import {destinosQuery} from "../../destinos/shared/data.service";
import {PassageiroDeslocamento} from "../../passageiros/shared/passageiro.model";
import {PassageiroApiService} from "../../passageiros/shared/passageiro-api.service";
import {TipoViagem} from "../../tipos-viagem/shared/tipo-viagem.model";
import {TipoViagemApiService} from "../../tipos-viagem/shared/tipo-viagem-api.service";

@Component({
    template: require('./deslocamento-form.component.html'),
    styles: [require('./deslocamento-form.component.css')]
})
export class DeslocamentoFormComponent implements OnInit, AfterViewChecked {
    deslocamentosModule: any = deslocamentosModuleName;
    module: any = viagensModuleName;
    formObject: any = new Deslocamento();
    funcionarioObject: any = new Funcionario();
    destinoObject: any = new Destino();
    tipoViagemObject: any = new TipoViagem();
    tipoObject: any = {};
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    isDriver: boolean = false;

    tipoDeslocSaida: number;
    tipoDeslocViagem: number;
    funcionarioSelectId: string = 'funcionario';
    funcionarioQuery: string;
    destinoSelectId: string = 'destino';
    destinoQuery: string;

    tiposList: any[] = [];
    passageirosList: any[] = [];
    tiposViagemList: TipoViagem[] = [];
    loadingSpinnerTiposViagem: boolean = true;

    form: FormGroup;
    ativo = new FormControl('');
    dataRetorno = new FormControl('', Validators.required);
    dataSaida = new FormControl('', Validators.required);
    horaSaida = new FormControl('', Validators.required);
    horaRetorno = new FormControl('', Validators.required);
    observacao = new FormControl('');
    funcionario = new FormControl('', Validators.required);
    tipo = new FormControl('', Validators.required);
    tipoViagem = new FormControl('');
    comMotorista = new FormControl('');
    enderecoPartidaSolicitante = new FormControl('', Validators.required);

    destino = new FormControl('', Validators.required);
    descricao = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseDeslocamento: any;
    private isEdition: boolean = false;

    constructor(
        private _route: ActivatedRoute,
        private _deslocamentoNavigationService: DeslocamentoNavigationService,
        private _deslocamentoApiService: DeslocamentoApiService,
        private _deslocamentoService: DeslocamentoService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _funcionarioApiService: FuncionarioApiService,
        private _funcionarioService: FuncionarioService,
        private _destinoApiService: DestinoApiService,
        private _passageiroApiService: PassageiroApiService,
        private _tipoViagemApiService: TipoViagemApiService,
        private _fb: FormBuilder,
        private _cdRef:ChangeDetectorRef
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            comMotorista: this.comMotorista,
            dataRetorno: this.dataRetorno,
            dataSaida: this.dataSaida,
            observacao: this.observacao,
            horaSaida: this.horaSaida,
            horaRetorno: this.horaRetorno,
            enderecoPartidaSolicitante: this.enderecoPartidaSolicitante,
            funcionario: this.funcionario,
            tipo: this.tipo,
            tipoViagem: this.tipoViagem,
            destino: this.destino,
            descricao: this.descricao
        });
    }

    ngOnInit() {
        this.funcionarioQuery =  this._utilService.cloneObject(funcionariosQueryComPessoa);
        this.destinoQuery =  this._utilService.cloneObject(destinosQuery);
        this.tiposList = this._utilService.cloneObject(tiposDeslocamentos);
        this.tipoDeslocSaida = this._deslocamentoService.getTipoSaida();
        this.tipoDeslocViagem = this._deslocamentoService.getTipoViagem();

        this.getTiposViagem();
        this.testSession();
    }

    ngAfterViewChecked() {
        this._cdRef.detectChanges();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    clickGoToDetail() {
        this.goToDetail();
    }

    changeTipo() {

    }

    onSubmit(evt: any) {
        this.submitted = true;

        if (!this.isDriver) {
            this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaSolicitante', 'x');
        }

        if (this.tipoObject.Key === this.tipoDeslocSaida) {
            this._utilService.setSelectOnFormControl(this.form, 'destino', {id: -1});
        }

        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:any = this._utilService.cloneObject(this.formObject),
                date: any, time: any;

            if (!this.isDriver) {
                object.enderecoPartidaSolicitante = '';
            }

            if (this.funcionarioObject.id) {
                object.solicitanteId = this.funcionarioObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.tipoObject.Key) {
                object.tipo = this.tipoObject.Key;

                if (this.tipoObject.Key === this.tipoDeslocViagem) {
                    if (this.destinoObject.id) {
                        object.destinoId = this.destinoObject.id;
                    } else {
                        this.btnSaveDisabled = false;
                        return false;
                    }
                }
            }

            if (this.tipoViagemObject.id) {
                object.tipoViagemId = this.tipoViagemObject.id;
            }

            date = document.getElementById('data_saida');
            time = document.getElementById('hora_saida');
            if (date.value && time.value) {
                object.dataHoraPrevistaSaida = this._utilService.convertStringToDateTime(date.value, time.value);
                delete object['dataSaida'];
                delete object['horaSaida'];
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            date = document.getElementById('data_retorno_previsto');
            time = document.getElementById('hora_retorno_previsto');
            if (date.value && time.value) {
                object.dataHoraPrevistaRetorno = this._utilService.convertStringToDateTime(date.value, time.value);

                delete object['dataRetorno'];
                delete object['horaRetorno'];
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.formObject.id) {
                this.onEditDeslocamento(object);
            } else {
                object.status = this._deslocamentoService.getStatusSolicitado();
                this.onAddDeslocamento(object);
            }
        }
    }

    getDestinoObject(object: any) {
        this.destinoObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'destino', object);
    }

    getFuncionariosObject(object: any) {
        this.funcionarioObject = object;
        this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
    }

    funcionarioTemplateResult = (function(state: any) {
        var template: any = this._funcionarioService.templateResult(state, false);
        return template;
    }.bind(this));

    private onAddDeslocamento(object: Deslocamento) {
        this._deslocamentoApiService.onPost(object, this.onDone);
    }

    private onEditDeslocamento(object: Deslocamento) {
        this._deslocamentoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseDeslocamento = Response;

            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            if (this.passageirosList.length && (Response.tipo === this.tipoDeslocViagem)) {
                this.sendPassageiros(Response.id);
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private sendPassageiros(deslocamentoId: number) {
        let x: number, lenX: number,
            passObject: any = {};
        for (x = 0, lenX = this.passageirosList.length; x < lenX; x++) {
            if (this.passageirosList[x].passageiro && !this.passageirosList[x].id) {
                passObject = {
                    deslocamentoId: deslocamentoId,
                    passageiroId: this.passageirosList[x].passageiro.id,
                    acompanhante: this.passageirosList[x].acompanhante
                };

                this.onAddPassageiro(passObject);
            }
        }
    }

    private onAddPassageiro(object: PassageiroDeslocamento) {
        let onDone = (function (Response: any) {
            if (!Response.error)  {
            }
        }.bind(this));

        this._passageiroApiService.onPostPassageiroDeslocamento(object, onDone);
    }

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma solicitação encontrada com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._deslocamentoApiService.onGetById(id, onDone);
    }

    private getTiposViagem() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.tiposViagemList = Response;
                this.setTipoViagem();
                this.loadingSpinnerTiposViagem = false;
            }
        }.bind(this));

        this._tipoViagemApiService.onGetAllActive(onDone);
    }

    private testSession() {
        this._deslocamentoService.clearSessionStorage();

        let id = +this._route.snapshot.params['id'];
        if (id) {
            this.setEditNormal(id);
        } else {
            this.setNewNormal();
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        if (this.formObject.enderecoPartidaSolicitante) {
            this.isDriver = true;
        }

        if (this.formObject.solicitante) {
            this.funcionarioObject = this.formObject.solicitante;
            delete this.formObject['solicitante'];

            let selectObject:any = {text: this.funcionarioObject.pessoa.nome, id: this.funcionarioObject.id};

            this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
        }

        if (this.formObject.destino) {
            this.destinoObject = this.formObject.destino;
            delete this.formObject['destino'];

            let selectObject:any = {text: this.destinoObject.destino, id: this.destinoObject.id};

            setTimeout(function() {
                this._autocompleteService.createOptionOnSelect2(this.destinoSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.destinoSelectId);
                this._utilService.setSelectOnFormControl(this.form, 'destino', this.destinoObject);
            }.bind(this));
        }

        if (this.formObject.tipo) {
            let x: number, lenX: number;
            for (x = 0, lenX = this.tiposList.length; x < lenX; x++) {
                if (this.tiposList[x].Key === this.formObject.tipo) {
                    this.tipoObject = this.tiposList[x];
                    break;
                }
            }
            delete this.formObject['tipo'];
        }

        if (this.formObject.tipoViagem) {
            this.tipoViagemObject = this.formObject.tipoViagem;
            delete this.formObject['tipoViagem'];
            this.setTipoViagem();
        }

        if (this.formObject.dataHoraPrevistaSaida) {
            if (this.formObject.dataHoraPrevistaSaida.indexOf("/") === -1) {
                this.formObject.dataSaida = this._utilService.convertDateToString(this.formObject.dataHoraPrevistaSaida);
                this.formObject.horaSaida = this._utilService.convertTimeToString(this.formObject.dataHoraPrevistaSaida);
            }
        }

        if (this.formObject.dataHoraPrevistaRetorno) {
            if (this.formObject.dataHoraPrevistaRetorno.indexOf("/") === -1) {
                this.formObject.dataRetorno = this._utilService.convertDateToString(this.formObject.dataHoraPrevistaRetorno);
                this.formObject.horaRetorno = this._utilService.convertTimeToString(this.formObject.dataHoraPrevistaRetorno);
            }
        }
    }

    private setTipoViagem() {
        if (this.tipoViagemObject.id) {
            let x: number, lenX: number;
            for (x = 0, lenX = this.tiposViagemList.length; x < lenX; x++) {
                if (this.tiposViagemList[x].id === this.tipoViagemObject.id) {
                    this.tipoViagemObject = this.tiposViagemList[x];
                    break;
                }
            }
        }
    }

    private toLeaveHere() {
        if (this.formObject.id) {
            this.goToDetail();
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._deslocamentoNavigationService.goToList();
    }

    private goToDetail() {
        this._deslocamentoNavigationService.goToDetail(this.formObject.id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRouteFemale;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        this.setFirstTipo();
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }

    private setFirstTipo() {
        if (this.isEdition) {

        } else {
            this.tipoObject = this.tiposList[0];
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamento-form/deslocamento-form.component.ts
 **/